import React, { useMemo } from "react";
import { Document, Page, Text, View, Image } from "@react-pdf/renderer";


const LecturePlanDoc = ({ studentList }) => {


    const studentdata = Array.isArray(studentList) ? studentList : [];
    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };
    const pages = useMemo(() => chunkArray(studentdata, 8), [studentdata]);
    return (
        <Document>
            {pages.map((pageData, pageIndex) => (
                <Page size="A4" orientation="landscape" style={{ padding: 30, fontSize: 10 }}>
                    <View
                        style={{
                            flexDirection: 'column',
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "1px",
                        }}>
                        <Image
                            src={'\public\sitLogo.jpg'}
                            style={{ width: "60px" }}
                        ></Image>

                    </View>

                    <View style={{
                        border: "3px solid black",
                        textAlign: "center",
                        padding: "5px",
                        fontWeight: "bold",
                        width: "100%"
                    }}>
                        <Text style={{ fontSize: 10 }}> LECTURE PLAN & DETAILS</Text>
                    </View>
                    <View style={{
                        marginTop: "5px",
                        width: "100%",
                        borderRight: "2px solid black",
                        borderTop: "2px solid black",
                        borderLeft: "2px solid black",
                        paddingTop: "10px",
                        paddingBottom: "5px",
                        textAlign: "center",
                        fontWeight: "bold",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        gap: "100px"
                    }}>
                        <Text style={{ fontSize: 10 }}> Training programme :   {studentdata[0].Course_Name} </Text>
                        <Text style={{ fontSize: 10 }}> Batch No :   {studentdata[0].Batch_code} </Text>
                        <Text style={{ fontSize: 10 }}> Category :   {studentdata[0].Category}</Text>
                    </View>

                    <View style={{

                        border: "2px solid black",
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        // height: "75%",
                    }}>


                        {/* part2 */}
                        < View style={{
                            width: "100%",

                            borderBottom: "1px solid black",
                            display: "flex",
                            flexDirection: "row",

                        }}>
                            <View style={{
                                // flex: 1,
                                borderRight: "1px solid black",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "5px",
                                paddingBottom: "2px",

                            }}>
                                <Text style={{
                                    fontSize: 10,
                                }}> Lecture </Text>
                                <Text style={{
                                    fontSize: 10,
                                }}> No. </Text>
                            </View>
                            <View style={{
                                flex: 1,
                                borderRight: "1px solid black",
                                justifyContent: "center",
                                alignItems: "center",

                            }}>
                                <Text style={{ fontSize: 10 }}>Planned</Text>
                                <Text style={{ fontSize: 10 }}>Date</Text>
                            </View>
                            <View style={{
                                flex: 1,
                                borderRight: "1px solid black",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "5px",
                                paddingBottom: "2px",
                            }}>
                                <Text style={{ fontSize: 10 }}>Planned</Text>
                                <Text style={{ fontSize: 10 }}>Time</Text>
                            </View>
                            {/* 3 in 1 */}
                            <View style={{
                                flex: 3,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRight: "1px solid black",
                                // paddingTop: "2px",
                                // paddingBottom: "2.5px",
                            }}>
                                <Text style={{
                                    fontSize: 10,
                                    paddingBottom: "1px",
                                }}> Lecture Content in Detail </Text>
                                <View style={{
                                    width: "100%",
                                    // height: "auto",
                                    borderTop: "1px solid black",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    // paddingTop: "2px",
                                    // paddingBottom: "2px",

                                }}>
                                    <View style={{
                                        width: "50%",
                                        height: '15px',
                                        borderRight: "1px solid black",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",

                                    }} >
                                        <Text style={{ fontSize: "10px" }}> Topic </Text>
                                    </View>
                                    <View style={{
                                        flex: 1,
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "50%",
                                    }}>
                                        <Text style={{ fontSize: "10px" }}> Sub Topic</Text>
                                    </View>
                                </View>

                            </View>

                            {/* 2 in 1 */}
                            <View style={{
                                flex: 2,
                                borderRight: "1px solid black",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "2.1px",
                                paddingBottom: "2px",
                            }}>
                                <View style={{
                                    width: "100%",
                                    borderBottom: "1px solid black",
                                    paddingBottom: "1px"
                                }}>
                                    <Text style={{ fontSize: 10 }}> Assignment</Text>
                                </View>
                                <View >
                                    <Text style={{
                                        fontSize: 10,
                                        paddingTop: "3px",
                                    }}> Test</Text>
                                </View>
                            </View>

                            {/* 1 */}
                            <View style={{
                                flex: 1.3,
                                borderRight: "1px solid black",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "5px",
                                paddingBottom: "3px",
                            }}>
                                <Text style={{ fontSize: 10 }}> Documents / Photocopy / LCD Required </Text>
                            </View>
                            <View style={{
                                flex: 2,
                                borderRight: "1px solid black",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "5px",
                                paddingBottom: "2px",
                            }}>
                                <Text style={{ fontSize: 10 }}> Faculty</Text>
                            </View>
                            <View style={{
                                flex: 1,
                                borderRight: "1px solid black",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "5px",
                                paddingBottom: "2px",
                            }}>
                                <Text style={{ fontSize: 10 }}> Actual </Text>
                                <Text style={{ fontSize: 10 }}>  Date</Text>
                            </View>
                            <View style={{
                                flex: 1,
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "5px",
                                paddingBottom: "2px",
                            }}>
                                <Text style={{ fontSize: 10 }}> Actual </Text>
                                <Text style={{ fontSize: 10 }}> Time</Text>
                            </View>


                        </View>
                        {/* part3 */}
                        {pageData.map((item, i) => (
                            <View style={{
                                display: "flex",
                                flexDirection: "row",
                                width: "100%",
                                height: "auto",
                                borderBottom: "1px solid black",

                            }}>
                                <View style={{
                                    // flex:0.452,
                                    width: "5.1%",
                                    borderRight: "1px solid black",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingTop: "6px",
                                    paddingBottom: "3px"

                                }}>
                                    <Text style={{ fontSize: 10 }}>{item.lecture_no}</Text>
                                </View>
                                <View style={{
                                    // flex: 0.670,
                                    width: "7.8%",
                                    borderRight: "1px solid black",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <View style={{ borderBottom: '1px solid black', width: '100%' }} >
                                        <Text style={{ fontSize: 10 }}> {item.lectureday} </Text>
                                    </View>
                                    <View>
                                        <Text style={{ fontSize: 10 }}> {item.planned} </Text>
                                    </View>
                                </View>
                                <View style={{
                                    // flex: 0.695,
                                    width: "7.8%",
                                    borderRight: "1px solid black",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <Text style={{ fontSize: 10 }}> {item.starttime}</Text>
                                    <Text style={{ fontSize: 10 }}> to </Text>
                                    <Text style={{ fontsize: 10 }}>{item.endtime}</Text>
                                </View>
                                <View style={{
                                    // flex: 2,
                                    width: "23%",
                                    borderRight: "1px solid black",
                                    display: "flex",
                                    flexDirection: "row",
                                }}>
                                    <View style={{
                                        width: "50%",
                                        borderRight: "1px solid black",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}>
                                        <Text style={{ fontSize: 10 }}>{item.Topic}</Text>

                                    </View>
                                    <View style={{
                                        width: "50%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}>
                                        <Text style={{ fontSize: 10 }}>{item.Topic}</Text>
                                    </View>
                                </View>
                                <View style={{
                                    // flex: 1.35,
                                    width: "15.4%",
                                    borderRight: "1px solid black",
                                    display: "flex",
                                    flexDirection: "column",
                                }}><View style={{
                                    width: "100%",
                                    // height: "20%",
                                    paddingTop: "7px",
                                    paddingBottom: "7px",
                                    borderBottom: "1px solid black",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                        <Text style={{ fontSize: 10 }}></Text>
                                    </View>
                                    <View style={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%",
                                        // height: "20%",
                                        paddingTop: "7px",
                                        paddingBottom: "7px",
                                    }}>
                                        <Text style={{ fontSize: 10 }}></Text>
                                    </View></View>

                                <View style={{
                                    // flex: 1,
                                    width: "10.1%",
                                    borderRight: "1px solid black",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <Text style={{ fontSize: 10 }}>{item.Documents_Required}</Text>
                                </View>
                                <View style={{
                                    // flex:1,
                                    width: "15.4%",
                                    borderRight: "1px solid black",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <Text style={{ fontSize: 9 }}>{item.Faculty_Name}</Text>
                                </View>
                                <View style={{
                                    // flex:1,
                                    width: "7.7%",
                                    borderRight: "1px solid black",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <Text style={{ fontSize: 10 }}>Wednesday  </Text>
                                    <Text style={{ fontSize: 10 }}>{item.Take_Dt}</Text>
                                </View>
                                <View style={{
                                    // flex: 1,
                                    width: "7.7%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <Text style={{ fontSize: 10 }}>{item.Lecture_Start}</Text>
                                    <Text style={{ fontSize: 10 }}> to </Text>
                                    <Text style={{ fontsize: 10 }}>{item.Lecture_End}</Text>
                                </View>


                            </View>
                        ))}

                    </View>

                    {/* part  4 */}

                    < View style={{
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingLeft: "30px",
                        paddingRight: "30px"
                    }}>
                        <View >
                            <Text style={{
                                fontSize: 10,
                                fontWeight: "extrabold",
                            }}>F/006B/04 </Text>
                        </View>

                        <View style={{
                            display: "flex",
                            flexDirection: "row",
                        }} >
                            <View >
                                <Text style={{
                                    fontSize: 10,
                                    fontWeight: "extrabold",
                                }}>Prepared by :  </Text>
                            </View>
                            <View >
                                <Text style={{
                                    fontSize: 10,
                                    fontWeight: "extrabold",
                                }}>___________________ </Text>
                            </View>
                        </View>

                        <View style={{
                            display: "flex",
                            flexDirection: "row",
                        }} >
                            <View >
                                <Text style={{
                                    fontSize: 10,
                                    fontWeight: "extrabold",
                                }}>Checked by :</Text>
                            </View>
                            <View >
                                <Text style={{
                                    fontSize: 10,
                                    fontWeight: "extrabold",
                                }}> ___________________</Text>
                            </View>
                        </View>
                        <View style={{
                            display: "flex",
                            flexDirection: "row",
                        }} >
                            <View >
                                <Text style={{
                                    fontSize: 10,
                                    fontWeight: "extrabold",
                                }}>Approved by : </Text>
                            </View><View >
                                <Text style={{
                                    fontSize: 10,
                                    fontWeight: "extrabold",
                                }}> ___________________</Text>
                            </View>
                        </View>

                        <View >
                            <Text style={{
                                fontSize: 10,
                                fontWeight: "extrabold",
                            }}>1 </Text>
                        </View>


                    </View>

                </Page>
            ))}
        </Document >
    );
};

export default LecturePlanDoc;
